import React, { FC, ReactNode } from 'react';
import { Modal as MModal } from '@mantine/core';
import classNames from 'classnames';

import styles from './styles.module.scss';

interface Props {
  opened: boolean;
  close: () => void;
  zIndex: number;
  withCloseButton?: boolean;
  size: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  padding: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  children: ReactNode;
  props? : any
}

const Modal: FC<Props> = ({ zIndex, withCloseButton, size, opened, close, children, padding='md' , ...props }) => {
  return (
    <MModal  opened={opened} onClose={close} zIndex={zIndex} withCloseButton={withCloseButton} size={size} padding={padding} { ...props}>
      {children}
    </MModal>
  );
};

export default Modal;
